const square = '\u00b2';
export const squareMeterShort = `м${square}`;
export const nbspJsString = '\xa0';
export const rubleSymbol = '₽';
